import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// "← Back to Today" — the way out of a detail page.
//
// Detail pages are reached from four different places (Today, the board, the
// Leads table, a direct link), so a hardcoded destination would be wrong three
// times out of four. The linking surface passes where it came from in the route
// state, and this renders that name; without it the link falls back to browser
// history, and without history — a bookmark, a refresh, a pasted URL — to the
// Pipeline, which is the app's home rather than a dead end.
//
// history.state.idx is React Router's own history index: 0 means this entry is
// the first in the session, so there is nothing behind it to go back to and
// navigate(-1) would leave the app entirely.
function hasHistory() {
  const idx = window.history.state && window.history.state.idx;
  return typeof idx === "number" ? idx > 0 : window.history.length > 1;
}

export default function BackLink({ fallback = "/", fallbackLabel = "Pipeline" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state && location.state.from;

  const label = (from && from.label) || (hasHistory() ? "Back" : fallbackLabel);

  const go = () => {
    if (from && from.to) navigate(from.to);
    else if (hasHistory()) navigate(-1);
    else navigate(fallback);
  };

  return (
    <button type="button" className="crm-back" onClick={go}>
      <span aria-hidden="true">←</span> {label === "Back" ? "Back" : `Back to ${label}`}
    </button>
  );
}
